import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit2 } from "react-icons/fi";
import api from "../../../utils/axiosConfig";
import { getApiUrl } from "../../../utils/urlHelper.js";

const ProfileImageEditor = () => {
  const [selfie, setSelfie] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Profile API से सिर्फ नाम लाएँ
    api
      .get("/profile")
      .then((res) => {
        setSelfie(res.data?.selfie || "");
      })
      .catch(() => setSelfie("selfie"));
  }, []);

  const handleEditClick = () => {
    navigate("/selfie-capture?from=profile");
  };

  return (
    <div className="Sefie-1 d" style={{ position: "relative", justifyContent: "space-between" }}>
      <div className="d a">
        <div style={{ position: "relative", display: "inline-block" }}>
          <img src={getApiUrl(selfie)} alt="avatar" />
          <button 
            type="button"
            onClick={handleEditClick}
            className="edit-selfie-btn"
            style={{
              position: "absolute",
              bottom: "-4px",
              right: "-4px",
              background: "var(--brand-600)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              padding: 0
            }}
            title="Update Selfie"
          >
            <FiEdit2 size={14} />
          </button>
        </div>
        <div>
          <p>Profile</p>
          <span style={{ fontSize: "12px", color: "var(--neutral-500)", fontWeight: "500" }}>Face ID</span>
        </div>
      </div>
      
      <button 
        type="button"
        className="secondarySmallButton" 
        onClick={handleEditClick}
        style={{ marginTop: 0 }}
      >
        Update
      </button>
    </div>
  );
};

export default ProfileImageEditor;
